import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, Card, Button, Stack, useTheme } from '@mui/material';
import { Add } from '@mui/icons-material';
import { PageHeader } from '@/components/layouts/PageHeader';
import { PageTabsBar } from '@/components/layouts/PageHeader/PageTabsBar';
import { useDispatch } from 'react-redux';
import { openDialog } from '@/features/dialog/dialogSlice';
import { TaskIcon } from '@/components/icons/TaskIcon';
import { paths } from '@/app/routes';
import { FolioErrorBoundary } from '@/components/layouts/FolioErrorBoundary';

const taskTabs = [
	{ label: 'In Progress', value: 'in-progress' },
	{ label: 'Completed', value: 'completed' },
];

export const TasksPage = () => {
	const theme = useTheme();
	const dispatch = useDispatch();
	const location = useLocation();
	const navigate = useNavigate();

	const currentTab = location.pathname.replace(paths.tasks, '').split('/').pop() ?? 'in-progress';

	const handleTabChange = (event, value) => {
		navigate(value);
	};

	const createButton = (
		<Button
			variant='contained'
			onClick={() => dispatch(openDialog({ dialogName: 'task', data: {} }))}
			startIcon={<Add />}
		>
			New Task
		</Button>
	);

	return (
		<Box pt={1}>
			<PageHeader
				title={'Tasks'}
				icon={
					<TaskIcon
						{...(theme.palette.mode === 'dark' && { bgColor: 'transparent' })}
					/>
				}
			/>

			<Stack>
				{currentTab && (
					<PageTabsBar
						tabs={taskTabs}
						value={currentTab}
						onChange={handleTabChange}
						actions={createButton}
					/>
				)}

				<Box sx={{ px: 3, pt: 1 }}>
					<FolioErrorBoundary
						key={currentTab}
						scope={currentTab}
						message='Error loading tab'
						context='TasksPage'
					>
						<Outlet />
					</FolioErrorBoundary>
				</Box>
			</Stack>
		</Box>
	);
};
TasksPage.displayName = 'TasksPage';
